<template>
	<div>
		<box :customer="true" :autoLoad="true" :ref="boxRef" title="进项发票" :width="1000" :index="0" @hide="hide"
			@submit="submit" moduleName="proofbill" :store="store" :selectType="selectType" @boxdataload="boxdataload" />
		<invoiceConfig ref="invoiceConfig" :invoicedata="invoicedata" :tab="['invoice']" title="发票预览" />	
	</div>
</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	import box from '@_system/components/formcomponents/common/box/index.vue'
	import invoiceConfig from '@/components/reports/reconciliationbankflow/lib/invoice/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			data: {
				type: Array,
				default: () => {
					return []
				}
			},
			buyerName: {
				default: () => {
					return null
				}
			},
			suplierName: {
				default: () => {
					return null
				}
			},
			selectType:{
				default: () => {
					return 'checkbox'
				}
			}
		},
		data() {
			return {
				index: 0,
				foreingKey: null,
				boxRef: 'box_' + Math.random(),
				box: null,
				invoicedata:[],
				boxConfig: {
					columns: [{
						field: 'invoiceNumber',
						title: '发票号',	
						render:"$input",
						slots:{
							default: ({row}) => {	
								if(row.invoiceStatus==3){
									if(row.invoiceId){
										return <el-link style="font-size:12px;" type="danger" onClick={()=>{this.preview(row)}} >{row.invoiceNumber}</el-link>
									}else{
										return <span style="color:#F56C6C">{row.invoiceNumber}</span>
									}									
								}else{
									if(row.invoiceId){
										return <el-link style="font-size:12px;" type="primary" onClick={()=>{this.preview(row)}} >{row.invoiceNumber}</el-link>
									}else{
										return <span >{row.invoiinvoiceNumbercecode}</span>
									}									
								}
							}
						}
					},{
						field: 'bizDate',
						title: '开票时间',	
						formatter:'date'
						
					},{
						field: 'buyerName',
						title: '购买方',
						render:"$input"
					},{
						field: 'suplierName',
						title: '销售方',
						render:"$input"
					},{
						field: 'totalPrice',
						title: '价税合计',
						render:"$inputNumber"
					},{
						field: 'supplierinvoicecode',
						title: '关联单据',
						render:"$input"
					}],	
					buttons:[],
					pagerConfig: {
						currentPage: 1,
						pageSize: 20,
						enabled: true,
						pageSizes: [10,20, 50, 200],
						force: false
					},
				},

			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box
			this.box.list = this.list
			this.box.show = this.show
			this.box.beforeCreateGrid = (formConfig,columns,gridOptions)=>{
				gridOptions.radioConfig.trigger = null
				gridOptions.checkboxConfig.trigger = null
			}
			this.box.checkMethod = ({
				row
			}) => {
				return row.invoiceStatus!=3
			}

		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},

		methods: {			
			show() {
				if (this.box.getTable()) {
					this.box.getTable().commitProxy('query')
				}
			},
			initList() {
				if (!this.box.gridOptions) {
					this.boxConfig.columns.forEach((item)=>{
						if(item.field == 'buyerName'){
							item.defaultValue = this.buyerName
						}
						if(item.field == 'suplierName'){
							item.defaultValue = this.suplierName
						}
					})
					console.log(this.boxConfig.columns)
					this.box.initBox(this.boxConfig)
				}
			},
			list(page, form, other) {
				let updateForm = JSON.parse(JSON.stringify(form))
				return new Promise((resolve) => {
					this.$api.invoice.listinputinvoice({
						...{enable:1},
						...page,
						...updateForm,
						...other
					}).then((res) => {
						resolve(res)
					}, () => {
						resolve()
					})
					// this.$api.qualitytest.purchaseDetail({
					// 	billtime:this.billtime,
					// 	mode: 'box',
					// 	index: this.index,
					// 	...page,
					// 	...form,
					// 	...this.foreingKey,
					// 	...other
					// }).then((res) => {
					// 	resolve({list:res})
					// }, () => {
					// 	reject()
					// })
				})
			},
			preview(row){
				//console.log(row)
				this.invoicedata = {
					invoiceNumber:row.invoiceNumber,
					customerId:row.customerId,
					invoiceId:row.invoiceId,
					invoiceType:row.invoiceType
				}
				this.$nextTick(()=>{
					this.$refs.invoiceConfig.modal_show()
				})
			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box,
			invoiceConfig
		}
	}
</script>